import { render, staticRenderFns } from "./InkInfo.vue?vue&type=template&id=447caa30&"
import script from "./InkInfo.vue?vue&type=script&lang=js&"
export * from "./InkInfo.vue?vue&type=script&lang=js&"
import style0 from "./InkInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports